// Stitching Service Upsell JavaScript
// File: assets/stitching-upsell.js

class StitchingUpsell {
  constructor() {
    this.selectedServices = [];
    this.stitchingCollection = 'stitching-services';
    this.services = [];
    this.currentProductTags = [];
    this.currencySymbol = '₹'; // Indian Rupee
    this.init();
  }

  async init() {
    console.log('Initializing stitching upsell...');
    
    try {
      // Wait for DOM to be ready
      await this.waitForElement('.product-form, form[action*="/cart/add"]');
      
      // Get product tags
      this.currentProductTags = this.getCurrentProductTags();
      
      // Load services
      await this.loadStitchingServices();
      
      // Filter services
      const filteredServices = this.filterServicesByTags();
      
      if (filteredServices.length > 0) {
        this.services = filteredServices;
        this.renderServices();
        this.bindEvents();
        
        // Disabled automatic moving - keep manual position
        // setTimeout(() => {
        //   this.moveUpsellSection();
        // }, 100);
        
        this.interceptAddToCart();
        console.log(`Initialized with ${this.services.length} services`);
      } else {
        const upsellSection = document.getElementById('stitching-upsell');
        if (upsellSection) {
          upsellSection.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Failed to initialize stitching upsell:', error);
    }
  }

  waitForElement(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  moveUpsellSection() {
    const upsellSection = document.getElementById('stitching-upsell');
    if (!upsellSection) return;

    // Find the add to cart button container with more specific selectors
    const addToCartSelectors = [
      '.product-options-bottom',
      '.add-to-cart-box', 
      '.product-form__buttons',
      '.product-action',
      '.actions',
      '.btn-cart',
      'button[name="add"]',
      '.product-form button[type="submit"]'
    ];

    let targetElement = null;
    for (const selector of addToCartSelectors) {
      const elements = document.querySelectorAll(selector);
      for (const element of elements) {
        // Look for the container that holds the add to cart functionality
        const container = element.closest('.product-options-bottom, .add-to-cart-box, .product-action, .actions, .form-group');
        if (container && (container.querySelector('.btn-cart') || container.querySelector('button[name="add"]') || container.querySelector('[type="submit"]'))) {
          targetElement = container;
          break;
        }
      }
      if (targetElement) break;
    }

    // Fallback: look for any form with add to cart action
    if (!targetElement) {
      const forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (const form of forms) {
        const submitBtn = form.querySelector('button[type="submit"], .btn-cart, button[name="add"]');
        if (submitBtn) {
          targetElement = submitBtn.closest('.product-options-bottom, .add-to-cart-box, .product-action, .actions') || submitBtn.parentElement;
          break;
        }
      }
    }

    if (targetElement && targetElement.parentNode) {
      // Move the upsell section before the add to cart button container
      targetElement.parentNode.insertBefore(upsellSection, targetElement);
      console.log('Moved upsell section above add to cart button');
    } else {
      console.log('Could not find suitable target element for moving upsell section');
    }
  }

  getCurrentProductTags() {
    try {
      const productData = document.querySelector('[data-product-json]');
      if (productData) {
        const product = JSON.parse(productData.textContent);
        return product.tags || [];
      }
      return [];
    } catch (error) {
      console.error('Could not get product tags:', error);
      return [];
    }
  }

  async loadStitchingServices() {
    try {
      const response = await fetch(`/collections/${this.stitchingCollection}/products.json?limit=250`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.products || !Array.isArray(data.products)) {
        this.services = [];
        return;
      }
      
      this.services = data.products
        .filter(product => {
          return product.available !== false && product.variants && product.variants.length > 0;
        })
        .map(product => {
          const variant = product.variants[0];
          // Handle image URL
          let imageUrl = null;
          if (product.images && product.images.length > 0) {
            const firstImage = product.images[0];
            
            if (typeof firstImage === 'object' && firstImage.src) {
              imageUrl = firstImage.src;
            } else if (typeof firstImage === 'string') {
              imageUrl = firstImage;
            }
            
            if (imageUrl) {
              imageUrl = String(imageUrl);
              if (!imageUrl.startsWith('http')) {
                imageUrl = `https:${imageUrl}`;
              }
            }
          }
          
          // Parse price correctly - it comes as a string like "400.00"
          let price = parseFloat(variant.price) || 0;
          let comparePrice = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
          
          // Extract SKU from variant or product
          const sku = variant.sku || product.sku || this.extractSKUFromTitle(product.title);
          
          return {
            id: product.id,
            variantId: variant.id,
            title: product.title,
            price: price, // This is now a number like 400.00
            comparePrice: comparePrice,
            image: imageUrl,
            available: variant.available !== false,
            tags: product.tags || [],
            handle: product.handle,
            sku: sku
          };
        });
        
      console.log(`Loaded ${this.services.length} stitching services`);
      if (this.services.length > 0) {
        console.log('Sample service:', this.services[0]);
        console.log('All service SKUs:', this.services.map(s => `${s.title}: ${s.sku}`));
      }
    } catch (error) {
      console.error('Error loading stitching services:', error);
      this.services = [];
    }
  }

  filterServicesByTags() {
    if (this.services.length === 0) {
      return [];
    }
    
    // Check if product has no-stitching tag (should be handled by Liquid, but double-check)
    if (this.currentProductTags.some(tag => tag.toLowerCase() === 'no-stitching')) {
      return [];
    }
    
    const productTagsLower = this.currentProductTags.map(tag => tag.toLowerCase());
    const hasTag = (...terms) => productTagsLower.some(tag => terms.some(term => tag.includes(term)));
    let allowedSKUs = [];

    // Finished garments and accessories must never receive another stitching upsell.
    if ((hasTag('stitched', 'readymade', 'ready-made', 'ready made') && !hasTag('unstitched')) ||
        hasTag('dupatta', 'jewellery', 'jewelry', 'bag', 'accessory')) {
      return [];
    }
    
    // Rule 1: Unstitched Kurti (takes priority over dress material)
    if (hasTag('unstitched kurti', 'kurti fabric')) {
      allowedSKUs.push('STITCHING002', 'STITCHING001', 'STITCHING009');
    }
    // Rule 2: Unstitched Suit or Dress Material (only if NOT unstitched kurti)
    else if (hasTag('unstitched suit', 'dress material', 'suit fabric')) {
      allowedSKUs.push('STITCHING012', 'STITCHING010', 'STITCHING011');
    }
    
    // Rule 3: Saree
    if (hasTag('saree')) {
      allowedSKUs.push('STITCHING003', 'STITCHING004');
      // Also add Fall & Picot (we'll identify it by title if SKU not available)
      allowedSKUs.push('FALL_PICOT'); // Placeholder, will match by title
    }
    
    // Blouse fabrics need blouse stitching; generic metre fabric gets only the
    // two broadly applicable kurti options instead of the entire service menu.
    if (hasTag('blouse fabric')) {
      allowedSKUs.push('STITCHING003', 'STITCHING004');
    } else if (hasTag('qty_meter') && allowedSKUs.length === 0) {
      allowedSKUs.push('STITCHING001', 'STITCHING002');
    }
    
    // If no rules matched, return empty array
    if (allowedSKUs.length === 0) {
      return [];
    }
    
    // Filter services based on allowed SKUs
    const filtered = this.services.filter(service => {
      const serviceSKU = service.sku;
      const serviceTitle = service.title.toLowerCase();
      
      // Check if service matches any allowed SKU
      const matchesSKU = allowedSKUs.some(sku => {
        if (sku === 'FALL_PICOT') {
          return serviceTitle.includes('fall') && serviceTitle.includes('picot');
        }
        // Match by SKU or by checking if SKU is in the title
        if (serviceSKU && serviceSKU.toUpperCase() === sku.toUpperCase()) {
          return true;
        }
        // Also check if the SKU appears in the title
        return serviceTitle.includes(sku.toLowerCase());
      });
      
      // Also check service tags for matching
      const matchesTags = service.tags && service.tags.some(tag => 
        allowedSKUs.includes(tag.toUpperCase())
      );
      
      // Also check if it's a numeric ID match (for qty_meter rule)
      const matchesId = allowedSKUs.includes(service.id);
      
      return matchesSKU || matchesTags || matchesId;
    });
    
    console.log('Product tags:', this.currentProductTags);
    console.log('Allowed SKUs:', allowedSKUs);
    console.log('Filtered services:', filtered.length);
    if (filtered.length > 0) {
      console.log('Filtered service details:', filtered.map(s => `${s.title} (SKU: ${s.sku})`));
    }
    
    return filtered;
  }
  
  extractSKUFromTitle(title) {
    // Try to extract SKU from title (e.g., "Kurti (no lining) - STITCHING002")
    const skuMatch = title.match(/STITCHING\d+/i);
    return skuMatch ? skuMatch[0].toUpperCase() : null;
  }

  renderServices() {
    const container = document.getElementById('stitching-services');
    if (!container) return;
    const upsellSection = document.getElementById('stitching-upsell');
    
    if (this.services.length === 0) {
      container.innerHTML = '<p style="text-align: center; color: #999;">No stitching services available.</p>';
      return;
    }

    container.innerHTML = this.services.map(service => {
      // Debug log for image URLs
      if (service.image) {
        console.log(`Service "${service.title}" image URL:`, service.image);
      }
      
      // Create clean image URL without size modification
      let imgTag = '';
      if (service.image) {
        // Use original URL without modifications
        imgTag = `<img src="${service.image}" 
                       alt="${service.title}" 
                       class="service-image-compact" 
                       loading="eager"
                       style="width: 100%; height: 85px; object-fit: cover; display: block;">`;
      } else {
        imgTag = `<div class="service-image-compact no-image">
          <span>${service.title.substring(0, 2).toUpperCase()}</span>
        </div>`;
      }
      
      return `
      <div class="service-item-compact" 
           data-service-id="${service.id}" 
           data-variant-id="${service.variantId}" 
           data-price="${service.price}"
           title="${service.title} - ${this.formatPrice(service.price)}">
        ${imgTag}
        <div class="service-label">
          <div class="service-title-compact">${this.truncateTitle(service.title)}</div>
          <div class="service-price-compact">${this.formatPrice(service.price)}</div>
        </div>
        <div class="service-checkbox">
          <span class="checkmark">✓</span>
        </div>
      </div>
    `}).join('');

    if (upsellSection) upsellSection.hidden = false;

    console.log(`Rendered ${this.services.length} services`);
    
    // Force image reload after rendering
    setTimeout(() => {
      document.querySelectorAll('.service-image-compact').forEach(img => {
        if (img.tagName === 'IMG' && !img.complete) {
          const src = img.src;
          img.src = '';
          img.src = src;
        }
      });
    }, 100);
  }

  truncateTitle(title) {
    // Extract key info from title
    if (title.toLowerCase().includes('no lining')) return 'No Lining';
    if (title.toLowerCase().includes('with lining')) return 'With Lining';
    if (title.toLowerCase().includes('top with lining')) return 'Top + Lining';
    if (title.toLowerCase().includes('kurti without')) return 'Kurti (No Lining)';
    if (title.toLowerCase().includes('kurti with')) return 'Kurti (Lining)';
    if (title.toLowerCase().includes('blouse without')) return 'Blouse (No Lining)';
    if (title.toLowerCase().includes('blouse with')) return 'Blouse (Lining)';
    if (title.toLowerCase().includes('pant') || title.toLowerCase().includes('palazzo') || title.toLowerCase().includes('bottom')) return 'Bottom';
    if (title.toLowerCase().includes('fall')) return 'Fall & Picot';
    if (title.toLowerCase().includes('custom')) return 'Custom';
    
    // Default: return first few words
    const words = title.split(' ');
    return words.slice(0, 2).join(' ');
  }

  bindEvents() {
    const toggle = document.querySelector('.stitching-upsell-toggle');
    const choices = document.getElementById('stitching-services-panel');
    if (toggle && choices) {
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        choices.hidden = expanded;
        const action = toggle.querySelector('.stitching-upsell-toggle__action');
        if (action) action.innerHTML = expanded ? 'View options <span aria-hidden="true">+</span>' : 'Hide options <span aria-hidden="true">−</span>';
      });
    }

    const modal = document.querySelector('.stitching-info-modal');
    const infoTrigger = document.querySelector('.stitching-info-trigger');
    if (modal && infoTrigger) {
      const closeButtons = modal.querySelectorAll('.stitching-info-modal__close, .stitching-info-modal__backdrop');
      const closeModal = () => { modal.hidden = true; document.body.classList.remove('stitching-modal-open'); infoTrigger.focus(); };
      infoTrigger.addEventListener('click', () => { modal.hidden = false; document.body.classList.add('stitching-modal-open'); modal.querySelector('.stitching-info-modal__close').focus(); });
      closeButtons.forEach(button => button.addEventListener('click', closeModal));
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && !modal.hidden) closeModal(); });
    }

    const servicesContainer = document.getElementById('stitching-services');
    if (servicesContainer) {
      servicesContainer.addEventListener('click', (e) => {
        const serviceItem = e.target.closest('.service-item-compact');
        if (serviceItem) {
          this.toggleService(serviceItem);
          console.log('Service toggled. Selected count:', this.selectedServices.length);
        }
      });
    }
  }

  interceptAddToCart() {
    console.log('Setting up add to cart interception...');
    
    // Wait a bit to ensure all theme JS is loaded
    setTimeout(() => {
      this.setupInterception();
    }, 1000);
  }
  
  setupInterception() {
    // Find ALL forms that could be product forms
    const productForms = document.querySelectorAll('form[action*="/cart/add"], .product-form, form.product-form, #product-main-form');
    
    productForms.forEach(form => {
      console.log('Processing form:', form);
      
      // Find ALL buttons that could trigger add to cart
      const buttons = form.querySelectorAll('button[type="submit"], input[type="submit"], .btn-cart, .add-to-cart, [name="add"]');
      
      buttons.forEach(button => {
        console.log('Found button:', button);
        
        // Create a new button to replace the original
        const newButton = document.createElement('button');
        newButton.type = 'button'; // NOT submit
        newButton.className = button.className;
        newButton.innerHTML = button.innerHTML;
        newButton.setAttribute('data-original-button', 'true');
        
        // Copy all attributes except type and onclick
        Array.from(button.attributes).forEach(attr => {
          if (attr.name !== 'type' && attr.name !== 'onclick' && attr.name !== 'class') {
            newButton.setAttribute(attr.name, attr.value);
          }
        });
        
        // Add our click handler
        const self = this;
        newButton.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          console.log('Custom button clicked!');
          self.handleCustomAddToCart(form);
          
          return false;
        };
        
        // Replace the original button
        button.parentNode.replaceChild(newButton, button);
        console.log('Replaced button with custom version');
      });
    });
    
    // Also prevent form submissions globally
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form && form.action && form.action.includes('/cart/add')) {
        console.log('Global form submit intercepted!');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.handleCustomAddToCart(form);
        return false;
      }
    }, true); // Use capture phase
  }
  
  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cart count in header - try multiple selectors
      const cartCountElements = document.querySelectorAll(
        '.cart-count, .cart-link__bubble, .site-header__cart-count, .cart-count-bubble, [data-cart-count], .header-cart-count, .cart-total-items'
      );
      
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        // Make sure it's visible
        if (cart.item_count > 0) {
          element.style.display = '';
          element.classList.remove('hidden');
        }
      });
      
      console.log('Cart count updated:', cart.item_count);
      return cart;
    } catch (error) {
      console.error('Failed to update cart count:', error);
    }
  }
  
  showSuccessMessage(customMessage) {
    // Remove any existing success message
    const existing = document.querySelector('.upsell-success-message');
    if (existing) {
      existing.remove();
    }
    
    const message = document.createElement('div');
    message.className = 'upsell-success-message';
    message.innerHTML = customMessage || '✓ Added to cart successfully!';
    
    // Add view cart link
    const viewCartLink = document.createElement('a');
    viewCartLink.href = '/cart';
    viewCartLink.style.cssText = 'display: block; margin-top: 8px; color: white; text-decoration: underline; font-size: 12px;';
    viewCartLink.textContent = 'View Cart →';
    message.appendChild(viewCartLink);
    
    document.body.appendChild(message);
    
    // Remove after 4 seconds
    setTimeout(() => {
      message.classList.add('fade-out');
      setTimeout(() => {
        if (document.body.contains(message)) {
          document.body.removeChild(message);
        }
      }, 300);
    }, 4000);
  }
  
  async handleCustomAddToCart(form) {
    console.log('handleCustomAddToCart called');
    
    // Find the button
    const button = form.querySelector('[data-original-button]') || form.querySelector('button');
    const originalText = button ? button.textContent : 'Add to Cart';
    
    try {
      // Get form data
      const formData = new FormData(form);
      let variantId = formData.get('id');
      
      // Try multiple ways to get variant ID
      if (!variantId) {
        const select = form.querySelector('select[name="id"]');
        if (select) variantId = select.value;
      }
      if (!variantId) {
        const input = form.querySelector('input[name="id"]');
        if (input) variantId = input.value;
      }
      if (!variantId) {
        // Look for variant selector
        const variantInputs = form.querySelectorAll('input[name="id"]:checked, input[type="radio"]:checked');
        if (variantInputs.length > 0) {
          variantId = variantInputs[0].value;
        }
      }
      
      const quantity = parseInt(formData.get('quantity')) || 1;
      
      console.log('Variant ID found:', variantId);
      console.log('Quantity:', quantity);
      console.log('Services selected:', this.selectedServices.length);
      
      if (!variantId) {
        alert('Please select a product variant');
        return;
      }
      
      // Disable button
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding to cart...';
      }
      
      // Create array of all items to add
      const itemsToAdd = [
        { id: variantId.toString(), quantity: quantity, title: 'Main Product' }
      ];
      
      // Add services if selected
      this.selectedServices.forEach(service => {
        itemsToAdd.push({
          id: service.variantId.toString(),
          quantity: 1,
          title: service.title
        });
      });
      
      console.log('Items to add:', itemsToAdd);
      
      // Add items one by one
      let successCount = 0;
      for (const item of itemsToAdd) {
        try {
          console.log(`Adding: ${item.title}`);
          
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: item.id,
              quantity: item.quantity
            })
          });
          
          if (response.ok) {
            const result = await response.json();
            console.log('Added successfully:', result);
            successCount++;
          } else {
            console.error(`Failed to add ${item.title}:`, await response.text());
          }
        } catch (error) {
          console.error(`Error adding ${item.title}:`, error);
        }
      }
      
      if (successCount > 0) {
        // Update cart count
        await this.updateCartCount();
        
        // Show success
        const message = this.selectedServices.length > 0 
          ? `✓ Added ${successCount} items to cart (product + ${this.selectedServices.length} services)`
          : `✓ Added ${quantity} item${quantity > 1 ? 's' : ''} to cart`;
        
        this.showSuccessMessage(message);
        
        // Clear services
        this.selectedServices = [];
        document.querySelectorAll('.service-item-compact.selected').forEach(item => {
          item.classList.remove('selected');
        });
        this.updateSummary();
        
        // Fire events for theme compatibility
        window.dispatchEvent(new CustomEvent('cart:added', { detail: { items: itemsToAdd } }));
        document.dispatchEvent(new CustomEvent('ajaxCart:added'));
        
        if (typeof jQuery !== 'undefined') {
          jQuery(document).trigger('cart.requestComplete');
        }
      } else {
        throw new Error('Could not add any items to cart');
      }
      
    } catch (error) {
      console.error('Cart error:', error);
      alert('Error: ' + error.message);
    } finally {
      // Re-enable button
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  }
  

  
  async handleAddToCartWithServices(form) {
    console.log('handleAddToCartWithServices called');
    
    try {
      // Get form data
      const formData = new FormData(form);
      let mainProductId = formData.get('id');
      
      if (!mainProductId) {
        const idInput = form.querySelector('select[name="id"], input[name="id"]');
        mainProductId = idInput?.value;
      }
      
      const quantity = parseInt(formData.get('quantity')) || 1;
      
      console.log('Main product ID:', mainProductId);
      console.log('Quantity:', quantity);
      console.log('Selected services:', this.selectedServices);
      
      if (!mainProductId) {
        throw new Error('Product ID not found');
      }
      
      // Disable button
      const submitButton = form.querySelector('button[type="submit"], .btn-cart');
      const originalText = submitButton?.textContent || 'Add to Cart';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Adding items...';
      }
      
      // Add main product first
      console.log('Adding main product to cart...');
      let response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: mainProductId,
          quantity: quantity
        })
      });
      
      if (!response.ok) {
        throw new Error('Failed to add main product to cart');
      }
      
      let result = await response.json();
      console.log('Main product added:', result);
      
      // Add each service
      for (const service of this.selectedServices) {
        console.log(`Adding service: ${service.title}`);
        
        response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: service.variantId.toString(),
            quantity: 1
          })
        });
        
        if (response.ok) {
          result = await response.json();
          console.log(`Service added:`, result);
        } else {
          console.error(`Failed to add service: ${service.title}`);
        }
      }
      
      // Show success
      this.showSuccessMessage();
      
      // Clear selection
      this.selectedServices = [];
      document.querySelectorAll('.service-item-compact.selected').forEach(item => {
        item.classList.remove('selected');
      });
      this.updateSummary();
      
      // Redirect to cart
      console.log('All items added, redirecting to cart...');
      setTimeout(() => {
        window.location.href = '/cart';
      }, 1500);
      
    } catch (error) {
      console.error('Error in handleAddToCartWithServices:', error);
      alert('Error adding items to cart: ' + error.message);
      
      // Re-enable button
      const submitButton = form.querySelector('button[type="submit"], .btn-cart');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText || 'Add to Cart';
      }
    }
  }

  toggleService(serviceElement) {
    const serviceId = serviceElement.dataset.serviceId;
    const variantId = serviceElement.dataset.variantId;
    const price = parseFloat(serviceElement.dataset.price);
    const service = this.services.find(s => s.id == serviceId);
    
    if (!service || !service.available) return;

    const isSelected = serviceElement.classList.contains('selected');
    
    if (isSelected) {
      serviceElement.classList.remove('selected');
      this.selectedServices = this.selectedServices.filter(s => s.id != serviceId);
    } else {
      serviceElement.classList.add('selected');
      this.selectedServices.push({
        id: serviceId,
        variantId: variantId,
        title: service.title,
        price: price
      });
    }

    this.updateSummary();
  }

  updateSummary() {
    const totalElement = document.getElementById('total-upsell-price');
    if (!totalElement) return;

    if (this.selectedServices.length === 0) {
      totalElement.textContent = '';
      totalElement.style.display = 'none';
    } else {
      const total = this.selectedServices.reduce((sum, service) => sum + service.price, 0);
      totalElement.textContent = `+${this.formatPrice(total)} for ${this.selectedServices.length} service${this.selectedServices.length > 1 ? 's' : ''}`;
      totalElement.style.display = 'block';
    }

    const addButton = document.querySelector('#product-main-form .add-to-cart');
    if (addButton) {
      const label = addButton.querySelector('span');
      const baseLabel = addButton.dataset.baseCtaLabel || 'Add to bag';
      if (label) label.textContent = this.selectedServices.length ? 'Add fabric + stitching' : baseLabel;
    }
    document.dispatchEvent(new CustomEvent('stitching:selection-change', { detail: { count: this.selectedServices.length } }));
  }



  showSuccessMessage() {
    const message = document.createElement('div');
    message.className = 'upsell-success-message';
    message.textContent = `✓ Added to cart successfully!`;
    document.body.appendChild(message);
    
    setTimeout(() => {
      message.classList.add('fade-out');
      setTimeout(() => {
        if (document.body.contains(message)) {
          document.body.removeChild(message);
        }
      }, 300);
    }, 3000);
  }

  formatPrice(priceValue) {
    // Prices from Shopify come as strings like "400.00" meaning ₹400.00
    // Just format them directly without division
    const price = parseFloat(priceValue) || 0;
    return `${this.currencySymbol} ${price.toFixed(2)}`;
  }

  stripHtml(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
  }
}

// Add styles
const style = document.createElement('style');
style.textContent = `
  /* Main container styles */
  #stitching-upsell {
    margin: 20px 0;
    padding: 0;
    border: none;
    background: transparent;
  }
  
  #stitching-upsell .upsell-header {
    margin-bottom: 15px;
    text-align: left;
  }
  
  #stitching-upsell .upsell-header h3 {
    font-size: 16px;
    font-weight: 600;
    color: #222;
    margin-bottom: 5px;
  }
  
  #stitching-upsell .upsell-header p {
    display: none;
  }
  
  /* Services grid - compact image style */
  #stitching-services {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .service-item-compact {
    position: relative;
    cursor: pointer;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    overflow: visible !important;
    transition: all 0.2s ease;
    background: white;
    width: 85px;
    display: flex;
    flex-direction: column;
  }
  
  .service-item-compact:hover {
    border-color: #999;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .service-item-compact.selected {
    border-color: #ff6b6b;
    background: #fff5f5;
  }
  
  .service-image-compact {
    width: 100% !important;
    height: 85px !important;
    object-fit: cover !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    border-radius: 6px 6px 0 0;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .service-image-compact.no-image {
    display: flex !important;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    color: #999;
    font-size: 18px;
    font-weight: bold;
  }
  
  .service-label {
    padding: 4px 6px;
    background: white;
    border-top: 1px solid #eee;
    border-radius: 0 0 6px 6px;
  }
  
  .service-title-compact {
    font-size: 11px;
    font-weight: 500;
    color: #333;
    line-height: 1.2;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .service-price-compact {
    font-size: 12px;
    font-weight: 700;
    color: #ff6b6b;
  }
  
  .service-checkbox {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 20px;
    height: 20px;
    background: white;
    border: 2px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.9;
  }
  
  .service-checkbox .checkmark {
    display: none;
    color: #ff6b6b;
    font-weight: bold;
    font-size: 14px;
  }
  
  .service-item-compact.selected .service-checkbox {
    background: #ff6b6b;
    border-color: #ff6b6b;
  }
  
  .service-item-compact.selected .service-checkbox .checkmark {
    display: block;
    color: white;
  }
  
  /* Summary */
  #selected-summary {
    display: none;
  }
  
  #total-upsell-price {
    font-size: 14px;
    color: #ff6b6b;
    font-weight: 600;
    display: block;
    margin: 10px 0;
    padding: 8px;
    background: #fff5f5;
    border-radius: 4px;
    text-align: center;
  }
  
  /* Success message */
  .upsell-success-message {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #4CAF50;
    color: white;
    padding: 15px 20px;
    border-radius: 4px;
    z-index: 10000;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    animation: slideIn 0.3s ease;
  }
  
  .upsell-success-message.fade-out {
    animation: fadeOut 0.3s ease;
  }
  
  @keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  
  @keyframes fadeOut {
    from { opacity: 1; }
    to { opacity: 0; }
  }
  
  /* Mobile responsive */
  @media (max-width: 480px) {
    .service-item-compact {
      width: 70px;
    }
    
    .service-image-compact {
      height: 70px !important;
    }
    
    #stitching-services {
      gap: 8px;
    }
  }
`;
document.head.appendChild(style);

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StitchingUpsell();
  });
} else {
  new StitchingUpsell();
}

window.StitchingUpsell = StitchingUpsell;
